module.exports = __webpack_public_path__ + "img/1-04.824c0543.png";